import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import InnerHTML from 'dangerously-set-html-content';
import { useParams,  useLocation } from "react-router-dom";

const SeoBlockEndCode = ({code}) => {
  const location = useLocation();
  const { city } = useParams();
  const subdomain = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? null : window.location.hostname.split('.')[0];
  // const [currentCity, setCurrentCity] = useState(((subdomain.length > 0) && subdomain !== 'staging' && subdomain !== 'proektmarketing') ? subdomain : "russia");
  let current_city = city;
  const root = useMemo(() => document.getElementById('body-end-code'), []);

  const code_subdomain =  `<!-- Yandex.Metrika counter -->
  <script type="text/javascript" >
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  
    ym(92755385, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true
    });
  </script>
  <noscript><div><img src="https://mc.yandex.ru/watch/92755385" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
  <!-- /Yandex.Metrika counter -->`;
  const code_folder = `<!-- Yandex.Metrika counter-->
  <script type="text/javascript" >
    // (function(m,e,t,r,i,k,a){m[i]=m[i]function(){(m[i].a=m[i].a[]).push(arguments)};
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  
    ym(93151002, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true
    });
  </script>
  <noscript><div><img src="https://mc.yandex.ru/watch/93151002" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
  <!-- /Yandex.Metrika counter -->`

  const googleMetriks = `<!-- Google tag (gtag.js) --> <script async src="https://www.googletagmanager.com/gtag/js?id=G-L3BGGZX4SV"></script> <script> window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-L3BGGZX4SV'); </script>`

  const result = code ? `${code}`: `${(current_city && (!subdomain || subdomain==="proektmarketing")) ? code_folder: ''} ${((subdomain && subdomain!=="proektmarketing") && !current_city) ? code_subdomain: ''}`;

  return !!root ? (
    ReactDOM.createPortal(
     <InnerHTML html={result} />,
      root
    )
  ) : (
    <></>
  );
}

export default SeoBlockEndCode;
